import { render } from "./PermissionsEditor.vue?vue&type=template&id=37d05270&scoped=true"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"

import "./PermissionsEditor.vue?vue&type=style&index=0&id=37d05270&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d05270"]])

export default __exports__